import {
  createSlice,
  createSelector,
  createAsyncThunk,
} from "@reduxjs/toolkit";
import { camelizeKeys } from "humps";
import { createWrapper } from "main/features/AxiosWrapper";
import {
  isPendingAction,
  isRejectedAction,
  isFulfilledAction,
} from "main/utils/sliceUtil";
import { HUBSPOT_FORM_ID, HUBSPOT_PORTAL_ID } from "main/constants/constant";
import { API_BASE_PATH } from "main/constants/constant";
import { getUtmValues } from "main/utils/googleAnalyticsUtil";

const key = "top";

const initialState: any = {
  error: null,
  loading: false,
};

interface HubSpotErrorResponse {
  errors?: string[];
  message: string;
  status: string;
}

/** Async * */
export const postTopContact = createAsyncThunk<
  any,
  {
    param: any;
  },
  {
    rejectValue: HubSpotErrorResponse;
  }
>(`${key}/postTopContact`, async (args, { rejectWithValue }) => {
  try {
    const { param } = args;
    const portalId = HUBSPOT_PORTAL_ID;
    const formGuid = HUBSPOT_FORM_ID;
    const url = `${API_BASE_PATH}/v1/inquiries`;
    const utmValues = getUtmValues();
    const hubspotParams = { ...param, ...camelizeKeys(utmValues) };
    const form = await createWrapper({ locale: "ja" }).post(url, param);
    hubspotParams["phone"] = form.data.phone;
    const result = await createWrapper({ withCredentials: false }).post(
      `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formGuid}`,
      {
        portalId,
        formGuid,
        fields: Object.keys(hubspotParams).map((key) => {
          return { name: key, value: hubspotParams[key] };
        }),
      },
    );
    return result.data;
  } catch (err) {
    return rejectWithValue(err.data);
  }
});

/** slice * */
export const topSlice = createSlice({
  name: key,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // 一旦slice単位で共通化
      .addMatcher(isPendingAction(key), (state) => {
        state.loading = true;
      })
      .addMatcher(isFulfilledAction(key), (state) => {
        state.loading = false;
      })
      .addMatcher(isRejectedAction(key), (state, action: any) => {
        state.error = action.payload?.error_messages;
        state.loading = false;
      });
  },
});

/** selector * */
const stateSelector = (state: { [key]: any }) => state[key];

export const loadingSelector = createSelector(
  stateSelector,
  (state) => state.loading,
);

// action export
